const ORDER_STATUS = {
    NEW: 'NEW',
    CONFIRMED: 'CONFIRMED',
    IN_DELIVERY: 'IN_DELIVERY',
    WITH_CUSTOMER: 'WITH_CUSTOMER',
    IN_PICKUP: 'IN_PICKUP',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED'
}

exports = module.exports = {
    ORDER_STATUS
}